import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import ArrowLineDown from '@icons/arrow/ArrowLineDown';
import { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
}

function ShopSelectorChip({ children }:Props) {
    return (
        <Container>
            <Text as='div' color={colors.textSecondary} fontWeight='bold' ellipsis >
                {children}
            </Text>
            <ArrowLineDown size={16} />
        </Container>
    );
}

const Container = styled.button`
    padding: var(--spacing-2) var(--spacing-4);
    display: flex;
    gap: var(--spacing-2);
    justify-content: center;
    align-items: center;
    border-radius: var(--radius-full);
    background-color: var(--color-background-disabled);
    max-width: 80vw;
    overflow: hidden;
`;

export default ShopSelectorChip;
